import { render, staticRenderFns } from "./PriceChart.vue?vue&type=template&id=06752ee8&scoped=true&"
import script from "./PriceChart.vue?vue&type=script&lang=ts&"
export * from "./PriceChart.vue?vue&type=script&lang=ts&"
import style0 from "./PriceChart.vue?vue&type=style&index=0&id=06752ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06752ee8",
  null
  
)

export default component.exports